import { render, staticRenderFns } from "./AuthorizationForm.vue?vue&type=template&id=a9153158&scoped=true"
import script from "./AuthorizationForm.vue?vue&type=script&lang=js"
export * from "./AuthorizationForm.vue?vue&type=script&lang=js"
import style0 from "./AuthorizationForm.vue?vue&type=style&index=0&id=a9153158&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9153158",
  null
  
)

export default component.exports